import { AppState } from '@fcom/core/interfaces';

import { UpcomingTrip } from './upcoming-trips.interface';

export const PNR_WIDGET_FEATURE_KEY = 'pnrWidget';

export interface UpcomingTripsState {
  upcomingTrips: UpcomingTrip[];
  status: UpcomingTripsFetchStatus;
}

export enum UpcomingTripsFetchStatus {
  INITIAL,
  FETCHED,
  ERROR,
}

export interface PnrWidgetState {
  tripsMmb: UpcomingTripsState;
}

export interface PnrWidgetFeatureState extends AppState {
  readonly [PNR_WIDGET_FEATURE_KEY]: PnrWidgetState;
}
